import type { RootState } from "store";
import { ActionTree } from "vuex";
import { SettingsService } from "../service";
import { SettingState } from "./types";

const service = new SettingsService()

export const actions: ActionTree<SettingState, RootState> = {

  async getSettings({ commit }, params: any) {
    const data = await service.getSettings()
    commit('SET_SETTINGS', data);
    return data
  },

  async deletePayLocation({ commit }, params: any) {
    const data = await service.deletePayLocation(params)
    return data
  },

  async patchSettings({ commit }, params: any) {
    const data = await service.patchSettings(params)
    commit('SET_SETTINGS', data);
  },
  
  async resetSetting({ commit }) {
    await service.resetSetting()
  },

  async patchPayLocation({ commit }, params: any) {
    await service.patchPayLocation(params)
  },
  
  async updatePayLocation({ commit }, params: any) {
    await service.updatePayLocation(params.data, params.id)
  },

  async dropdownPayLocation({ commit }, params: any) {
    let filter = ``;
    if (params.search) {
      filter = `contains(tolower(Name),'${params.search.toLowerCase()}')`
    }
    params.filter = filter;
    const selectProps = "PayLocationId, Name, Region"; 
    const data = await service.dropdownPayLocation(selectProps, params)
    commit('SET_PAYLOCATION_COUNT', data["@odata.count"])
    return data.value
  },


};